import gate from "../../../gate/gate";
import client from "@https/api";
import {
  IFestivalProductInput,
  IFestivalProductParams,
  IFestivalResponse,
} from "../types";

const festivalApi = {
  getData: (slug: string, access_mode?: string) =>
    gate.get<IFestivalResponse, never, { access_mode?: string }>({
      client,
      url: `/festivals/${slug}`,
      params: access_mode ? { access_mode } : {},
    }),
  getProducts: (slug: string, params?: IFestivalProductParams) =>
    gate.get<IFestivalProductInput, never, any>({
      client,
      url: `/festivals/${slug}/products`,
      params,
    }),
};

export default festivalApi;
